import moment from 'moment';
import { getEstimateLatestActions } from '../../HttpRequests/estimateLatestActions';
import { loadEstimateLatestActions } from '../State/estimateLatestActions';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getEstimateLatestActions();

    dispatch(loadEstimateLatestActions(response.data.data));

  } catch (error) {
    
    throw error;

  }
}